module.exports = __webpack_public_path__ + "media/offers_icons/ciezarowe-blue-7bccc863.svg";